module.exports = __webpack_public_path__ + "img/chart.2f82ae1.png";